import { render, staticRenderFns } from "./File.vue?vue&type=template&id=2bfca791&scoped=true&"
import script from "./File.vue?vue&type=script&lang=js&"
export * from "./File.vue?vue&type=script&lang=js&"
import style0 from "./File.vue?vue&type=style&index=0&id=2bfca791&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfca791",
  null
  
)

export default component.exports